// extracted by mini-css-extract-plugin
module.exports = {"right-edit-wrap":"edit_style_right-edit-wrap__2BipQ"};